<div class="d-flex align-items-center justify-content-between">

  <page-heading
    [title]="'channel.channelConfig.summaryTitle' | translate"
    [description]="'channel.channelConfig.summaryDescription' | translate"
  />

  @if(channel?.type === 'Z_API') {
    <div class="d-flex align-items-center gap-3 p-3 border border-1 border-secondary-subtle rounded">

      <!-- <div class="custom-switch mb-2">
        <input
          type="checkbox"
          id="limitAttendancePerAttendant"
          data-switch="success"
          formControlName="limitAttendancePerAttendant"
          tabindex="0"
          [checked]="checkedRejectCallAuto"
          [disabled]="isLoadingRejectCallAuto"
          (change)="handleRejectCallAuto($event)"
        />
        <label for="limitAttendancePerAttendant">
          <span class="d-block fw-bold">
            {{ 'channel.channelConfig.rejectCallsAuto' | translate }} <br />
            <small>{{ 'channel.channelConfig.rejectCallsAutoDescription' | translate }}</small>
          </span>
        </label>
      </div> -->

      <mat-slide-toggle class="ms-2"
        (change)="handleRejectCallAuto($event)"
        [checked]="checkedRejectCallAuto"
        [disabled]="isLoadingRejectCallAuto"
        [color]="'primary'">
      </mat-slide-toggle>

      <div>
        <span class="fw-medium text-dark">{{ 'channel.channelConfig.rejectCallsAuto' | translate }}</span>
        <p class="small text-secondary mt-1 mb-0">
          {{ 'channel.channelConfig.rejectCallsAutoDescription' | translate }}
        </p>
      </div>

    </div>
  }
</div>

@if (!loadingContent) {
  @if (channel?.type === voipAPI) {
    <div class="grid-cards">
      <card-graphic-small-legacy-component [label]="'channel.channelConfig.voipCallsMade' | translate"
        [total]="totalCallsMade"
      />
      <card-graphic-small-legacy-component [label]="'channel.channelConfig.voipCallsReceived' | translate"
        [total]="totalCallsReceived"
      />
    </div>
  } @else {
  <div class="grid-cards">
    <card-graphic-small-legacy-component [label]="'channel.channelConfig.messages' | translate"
      [total]="totalMessages"
    />
    <card-graphic-small-legacy-component [label]="'channel.channelConfig.attendances' | translate"
      [total]="totalAttendances"
    />
    <card-graphic-small-legacy-component [label]="'channel.channelConfig.contacts' | translate"
      [total]="totalContacts"
    />
  </div>
  }
}

@if (channel?.type === voipAPI) {
  <div class="mt-3">
    <channel-voip-ramais-component [channel]="channel" />
  </div>
}

@if (channel?.type === webchatAPI) {
  <div class="mt-3">
    <channel-webchat-component [channel]="channel" />
  </div>
}

@if (channel?.type !== voipAPI) {
<div class="grid-cards-charts">

  <div class="card">
    <div class="d-flex flex-column card-header">
      <h3>{{ 'channel.channelConfig.metrics' | translate }}</h3>
      <h5 class="text-muted fw-normal">{{ 'channel.channelConfig.sentReceivedMessages' | translate }}</h5>
    </div>
    <div class="card-grid-body">
      <ngx-charts-bar-vertical-stacked
        [xAxis]="true"
        [yAxis]="true"
        [results]="dataChartOfChannel"
        [showYAxisLabel]="true"
        [customColors]="customColors"
      />
    </div>
  </div>

  @if (loadingSpinner$ | async) {
    <loading-component />
  } @else {
    <div class="card">
      @if(channel.type === cloudAPI) {
        @if(channel.connected) {
          <div class="channel-card__body">
            <div class="d-flex justify-content-end">
              <span class="badge campaign-badge is-ok status-badge status-badge--connected">
                <i class="status-dot status-dot--connected"></i>
                {{ 'channel.channelConfig.connected' | translate }}
              </span>
            </div>
            <div class="channel-card__icon">
              <div class="icon-wrapper icon-wrapper--official">
                <img
                  src="../../../../assets/images/icon-whatsapp.svg"
                  [alt]="'channel.channelConfig.whatsappBusinessAlt' | translate"
                >
                <span class="official-badge" [class.official-badge--hybrid]="channel?.hybrid">
                  <i class="mdi mdi-check-decagram"></i>
                </span>
              </div>
            </div>
            <div class="channel-card__content">
              <h5 class="channel-card__title">{{ channel.name }}</h5>
              <p class="channel-card__type">{{ channel?.identifier ?? ('channel.channelConfig.noIdentifier' | translate) }}</p>
              @if (channel?.creditLine) {
                <p class="channel-card__type">
                  <span class="badge bg-soft-primary text-primary">
                    <i class="ri-bank-card-line me-1"></i>{{ 'channel.channelList.creditLineBadge' | translate }}
                  </span>
                </p>
              }
              @if (channel?.hybrid) {
                <p class="channel-card__type">
                  <span class="badge bg-soft-primary text-primary">
                    <i class="ri-git-branch-line me-1"></i>{{ 'channel.channelList.hybridBadge' | translate }}
                  </span>
                </p>
              }
            </div>
          </div>
        } @else {
            <div class="channel-card__body d-flex justify-content-center align-items-center">
              <div class="d-flex justify-content-center align-items-center">
                <app-whatsapp-signup [nameChannel]="channel.name" [idChannel]="channel._id" [creditLine]="!!channel.creditLine" [hybrid]="!!channel.hybrid"
                  (onSave)="onEmbeddedConnected($event)">
                </app-whatsapp-signup>
              </div>
            </div>
        }
      } @else {
        <div class="channel-card__body">

          <div class="d-flex justify-content-end">
            <span
              class="badge campaign-badge status-badge"
              [ngClass]="{
                'is-ok status-badge--connected': channel.connected,
                'is-err status-badge--disconnected': !channel.connected
              }"
            >
              <i class="status-dot" [ngClass]="{
                'status-dot--connected': channel.connected,
                'status-dot--disconnected': !channel.connected
              }"></i>
              {{ (channel.connected ? 'channel.channelConfig.connected' : 'channel.channelConfig.disconnected') | translate }}
            </span>
          </div>

          <div class="channel-card__icon">
            @if ((!channel.connected && channel?.type === zAPI) && INSTANCE_CODE_DATA) {
              <qrcode
                [qrdata]="INSTANCE_CODE_DATA"
                [imageSrc]="'../../../../assets/images/logo-icon-sidebar.png'"
                [imageWidth]="50"
                [imageHeight]="50"
                [width]="456"
              />
            }

            @if (channel.connected && channel?.type === zAPI) {
              <div class="icon-wrapper icon-wrapper--unofficial">
                <img
                  src="../../../assets/images/icon-whatsapp.svg"
                  [alt]="'channel.channelConfig.whatsappUnofficialAlt' | translate"
                >
              </div>
            }

            @if (channel?.type === instagramAPI) {
              <div class="icon-wrapper icon-wrapper--unofficial">
                <img
                  src="../../../../../../../assets/images/icon-instagram.png"
                  [alt]="'channel.channelConfig.instagramAlt' | translate"
                  width="50"
                  height="50"
                >
              </div>
            }

            @if (channel?.type === messengerAPI) {
              <div class="icon-wrapper icon-wrapper--unofficial">
                <img
                  src="../../../../../../../assets/images/icon-messenger.png"
                  [alt]="'channel.channelConfig.messengerAlt' | translate"
                  width="50"
                  height="50"
                >
              </div>
            }

            @if (channel.type === rcsAPI) {
              <div class="icon-wrapper icon-wrapper--unofficial">
                <img
                  src="/assets/images/Google-Messages.png" height="48"
                  [alt]="'channel.channelConfig.rcsImageAlt' | translate"
                >
              </div>
            }

            @if (channel?.type === webchatAPI) {
              <div class="icon-wrapper icon-wrapper--unofficial">
                <i class="mdi mdi-chat font-48 text-primary"></i>
              </div>
            }

          </div>

          <div class="channel-card__content">
            <h5 class="channel-card__title">{{ channel.name }}</h5>
            <p class="channel-card__type">{{ channel?.identifier ?? ('channel.channelConfig.noIdentifier' | translate) }}</p>
          </div>

        </div>
      }
    </div>

  }

</div>
}

@if (isReconnectableChannel() && !channel?.connected) {
  <div class="row mt-3">
    <div class="col-12">
      <div class="alert alert-warning mb-0" role="alert">
        <i class="ri-error-warning-line me-1"></i>
        {{ (isCloudAPIChannel() ? 'channel.channelConfig.cloudApiDisconnectedHint' : 'channel.channelConfig.metaDisconnectedHint') | translate }}
      </div>
    </div>
  </div>
}

<!-- Hybrid channel: session side + official share (SPEC-2026-10-whatsapp-hybrid-channel RF-02/RF-26) -->
@if (channel?.type === cloudAPI && channel?.hybrid) {
  <channel-hybrid-session-component [channel]="channel" (channelChange)="channel = $event" />
}

<hr class="mt-4"/>

<div class="row mt-4">
  <div class="col-12 gap-2 d-flex justify-content-end pb-4 align-items-baseline">
    @if ((channel?.type === 'Z_API' && isRoot()) || channel?.type !== 'Z_API') {
      <button
        class="btn btn-outline-danger"
        (click)="onDelete(channel)"
      >
        {{ 'channel.channelConfig.remove' | translate }}
      </button>
    }

    @if (channel.connected) {
      @if (channel?.type !== 'CLOUD_API' && channel?.type !== 'INSTAGRAM_API' && channel?.type !== 'MESSENGER_API' && channel?.type !== 'RCS_API' && channel?.type !== 'VOIP_API' && channel?.type !== 'WEBCHAT_API') {
        <button
          class="btn btn-outline-primary"
          (click)="restart()"
          [disabled]="loading"
        >
          @if (!loading) {
            <i class="ri-restart-line"></i>
            {{ 'channel.channelConfig.restart' | translate }}
          } @else {
            <mat-spinner [diameter]="20" mode="indeterminate" />
          }
        </button>

        <button
          class="btn btn-outline-primary"
          (click)="syncContacts()"
          [disabled]="loading"
        >
          @if (!loading) {
            <i class="ri-refresh-line"></i>
            {{ 'channel.channelConfig.syncContacts' | translate }}
          } @else {
            <mat-spinner [diameter]="20" mode="indeterminate" />
          }
        </button>

        <button
          class="btn"
          [ngClass]="loading ? 'btn-outline-primary' : 'btn-danger'"
          (click)="disconnect()"
          [disabled]="loading"
        >
          @if (!loading) {
            <i class=" ri-plug-line"></i>
            {{ 'channel.channelConfig.disconnect' | translate }}
          } @else {
            <mat-spinner [diameter]="20" mode="indeterminate" />
          }
        </button>
      }
    }

    <!-- Cloud API: same reconnect path as Instagram/Messenger, through the Embedded Signup instead
         of a Facebook Login redirect. Reconnecting refreshes only the connection data, so the channel
         and its conversation history are kept — deleting it was the only way out before. -->
    @if (isCloudAPIChannel()) {
      @if (channel.connected) {
        <button
          class="btn"
          [ngClass]="loading ? 'btn-outline-primary' : 'btn-danger'"
          (click)="disconnect()"
          [disabled]="loading"
        >
          @if (!loading) {
            <i class="ri-plug-line"></i>
            {{ 'channel.channelConfig.disconnect' | translate }}
          } @else {
            <mat-spinner [diameter]="20" mode="indeterminate" />
          }
        </button>

        <app-whatsapp-signup
          [nameChannel]="channel.name"
          [idChannel]="channel._id"
          [creditLine]="!!channel.creditLine" [hybrid]="!!channel.hybrid"
          [labelKey]="'whatsappSignup.home.reconnectButton'"
          [buttonClass]="'btn btn-outline-primary'"
          [disabledButton]="loading"
          (onSave)="onEmbeddedConnected($event)"
        />
      }
    }

    <!-- Instagram/Messenger: an expired Meta token cannot be renewed, so the channel is
         disconnected and reconnected through a new authorization — never deleted, which would take
         its conversation history with it. -->
    @if (isMetaChannel()) {
      @if (channel.connected) {
        <button
          class="btn"
          [ngClass]="loading ? 'btn-outline-primary' : 'btn-danger'"
          (click)="disconnect()"
          [disabled]="loading"
        >
          @if (!loading) {
            <i class="ri-plug-line"></i>
            {{ 'channel.channelConfig.disconnect' | translate }}
          } @else {
            <mat-spinner [diameter]="20" mode="indeterminate" />
          }
        </button>
      }

      <button
        class="btn btn-outline-primary"
        (click)="reconnect()"
        [disabled]="loading"
      >
        <i class="ri-link"></i>
        {{ 'channel.channelConfig.reconnect' | translate }}
      </button>
    }

    @if (channel?.type !== 'CLOUD_API' && channel?.type !== 'INSTAGRAM_API' && channel?.type !== 'MESSENGER_API' && channel?.type !== 'RCS_API' && channel?.type !== 'VOIP_API' && channel?.type !== 'WEBCHAT_API') {
      <button
        class="btn btn-outline-primary"
        (click)="sync()"
        [disabled]="loading"
      >
        @if (!loading) {
          <i class="ri-refresh-line"></i>
          {{ 'channel.channelConfig.sync' | translate }}
        } @else {
          <mat-spinner [diameter]="20" mode="indeterminate" />
        }
      </button>
    }

    <button
      class="btn btn-success"
      (click)="edit(channel)"
    >
      {{ 'channel.channelConfig.edit' | translate }}
    </button>
  </div>
</div>
